import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddEditCandidateContactOneModule } from './add-edit-candidate-contact-one/add-edit-candidate-contact-one.module';
import { CandidateAdditionalDetailsModule } from './candidate-additional-details/candidate-additional-details.module';
import { AddEditCandidateContactModule } from './add-edit-candidate-contact/add-edit-candidate-contact.module';
import { FourDotFivePhoneNumberModule } from './four-dot-five-phone-number/four-dot-five-phone-number.module';
import { ManageEntityLocationModule } from './manage-entity-location/manage-entity-location.module';
import { InfoIconModule } from './info-icon/info-icon.module';
import { SkeletonLoaderModule } from './skeleton-loader/skeleton-loader.module';
import { ActionLessHeaderModule } from './action-less-header/action-less-header.module';
import { CandidateCardIconsModule } from './candidate-card-icons/candidate-card-icons.module';
import { WorkLocationsIconModule } from './work-locations-icon/work-locations-icon.module';
import { CandidateActionsModule } from './candidate-actions/candidate-actions.module';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { RequisitionCardIconsModule } from './requisition-card-icons/requisition-card-icons.module';
import { RecentActivitiesModule } from './recent-activities/recent-activities.module';
import { EntityActivitiesModule } from './entity-activities/entity-activities.module';
import { SetCandidateAvailabilityOrJobLeftDateModule } from './set-candidate-availability-or-job-left-date/set-candidate-availability-or-job-left-date.module';
import { DoNotHireModule } from './do-not-hire/do-not-hire.module';
import { ExternalNotesModule } from './external-notes/external-notes.module';
import { UserCommunicationModule } from './user-communication/user-communication.module';
import { JobMatchActionsModule } from './job-match-actions/job-match-actions.module';
import { DeleteEntityModule } from './delete-entity/delete-entity.module';
import { RequisitionSkillsModule } from './requisition-skills/requisition-skills.module';
import { UploadFilesModule } from './upload-files/upload-files.module';
import { SendCandidateOutreachEmailModule } from './send-candidate-outreach-email/send-candidate-outreach-email.module';
import { JobLeftModule } from './job-left/job-left.module';
import { FillOrJoinCandidateModule } from './fill-or-join-candidate/fill-or-join-candidate.module';
import { EmailClientReviewModule } from './email-client-review/email-client-review.module';
import { EmailHtmlEditorModule } from './email-html-editor/email-html-editor.module';
import { AiAssistantModule } from './ai-assistant/ai-assistant.module';
import { IncludeDetailsCheckboxesModule } from './include-details-checkboxes/include-details-checkboxes.module';
import { CompaniesModule } from './companies/companies.module';
import { HiringManagersPopoverModule } from '../pages/mission-control-page/requisitions-page/requisition-card/hiring-managers-popover/hiring-managers-popover.module';
import { RecruitersPopoverModule } from '../pages/mission-control-page/requisitions-page/requisition-card/recruiters-popover/recruiters-popover.module';
import { RequisitionCardActionsModalModule } from '../pages/mission-control-page/requisitions-page/requisition-card/requisition-card-actions-modal/requisition-card-actions-modal.module';
import { RequisitionActionModalModule } from '../pages/mission-control-page/requisitions-page/requisition-card/requisition-action-modal/requisition-action-modal.module';
import { RequisitionBackwardActionModalModule } from '../pages/mission-control-page/requisitions-page/requisition-card/requisition-backward-action-modal/requisition-backward-action-modal.module';
import { RequisitionActivityModalModule } from '../pages/mission-control-page/requisitions-page/requisition-card/requisition-activity-modal/requisition-activity-modal.module';
import { RequisitionCardModule } from '../pages/mission-control-page/requisitions-page/requisition-card/requisition-card.module';
import { OverrideCandidateSuspensionModule } from './override-candidate-suspension/override-candidate-suspension.module';
import { AddEditDocumentFolderModule } from '../pages/mission-control-page/candidateprofile-page/add-edit-document-folder/add-edit-document-folder.module';
import { DeleteCandidateDocumentModule } from '../pages/mission-control-page/candidateprofile-page/delete-candidate-document/delete-candidate-document.module';
import { MoveDocumentFolderModule } from '../pages/mission-control-page/candidateprofile-page/move-document-folder/move-document-folder.module';
import { DocumentsTreeModule } from '../pages/mission-control-page/candidateprofile-page/documents-tree/documents-tree.module';
import { AvailableDocumentsModule } from '../pages/mission-control-page/candidateprofile-page/available-documents/available-documents.module';
import { UploadCandidateDocumentModule } from '../pages/mission-control-page/candidateprofile-page/upload-candidate-document/upload-candidate-document.module';
import { EmailDocumentsModule } from '../pages/mission-control-page/candidateprofile-page/email-documents/email-documents.module';
import { CandidateDocumentsModule } from '../pages/mission-control-page/candidateprofile-page/candidate-documents/candidate-documents.module';
import { CandidateProfileActionsModalModule } from '../pages/mission-control-page/candidateprofile-page/candidate-profile-actions-modal/candidate-profile-actions-modal.module';
import { CandidateProfileModule } from '../pages/mission-control-page/candidateprofile-page/candidate-profile/candidate-profile.module';
import { UploadReqWorkFlowStepWarningModalModule } from '../pages/mission-control-page/upload-req-page/upload-req-work-flow-step-warning-modal/upload-req-work-flow-step-warning-modal.module';
import { UploadReqUpdateLocationModalModule } from '../pages/mission-control-page/upload-req-page/upload-req-update-location-modal/upload-req-update-location-modal.module';
import { UploadReqTransactionCandidatesModalModule } from '../pages/mission-control-page/upload-req-page/upload-req-transaction-candidates-modal/upload-req-transaction-candidates-modal.module';
import { UploadReqJobProfileModalModule } from '../pages/mission-control-page/upload-req-page/upload-req-job-profile-modal/upload-req-job-profile-modal.module';
import { UploadReqAddEditEndClientModalModule } from '../pages/mission-control-page/upload-req-page/upload-req-add-edit-end-client-modal/upload-req-add-edit-end-client-modal.module';
import { ReviewCandidatePullFromJobBoardsModule } from './review-candidate-pull-from-job-boards/review-candidate-pull-from-job-boards.module';
import { UserNotificationsModule } from './user-notifications/user-notifications.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    FourDotFivePhoneNumberModule,
    ManageEntityLocationModule,
    AddEditCandidateContactOneModule,
    CandidateAdditionalDetailsModule,
    AddEditCandidateContactModule,
    InfoIconModule,
    SkeletonLoaderModule,
    ActionLessHeaderModule,
    CandidateCardIconsModule,
    WorkLocationsIconModule,
    CandidateActionsModule,
    RequisitionCardIconsModule,
    RecentActivitiesModule,
    EntityActivitiesModule,
    SetCandidateAvailabilityOrJobLeftDateModule,
    DoNotHireModule,
    ExternalNotesModule,
    UserCommunicationModule,
    JobMatchActionsModule,
    DeleteEntityModule,
    RequisitionSkillsModule,
    UploadFilesModule,
    SendCandidateOutreachEmailModule,
    JobLeftModule,
  FillOrJoinCandidateModule,
  EmailClientReviewModule,
  EmailHtmlEditorModule,
    FillOrJoinCandidateModule,
    AiAssistantModule,
  IncludeDetailsCheckboxesModule,
  CompaniesModule,
  HiringManagersPopoverModule,
  RecruitersPopoverModule,
  RequisitionCardActionsModalModule,
  RequisitionActionModalModule,
  RequisitionBackwardActionModalModule,
  RequisitionActivityModalModule,
  RequisitionCardModule,
  OverrideCandidateSuspensionModule,
  AddEditDocumentFolderModule,
  DeleteCandidateDocumentModule,
  MoveDocumentFolderModule,
  DocumentsTreeModule,
  AvailableDocumentsModule,
  UploadCandidateDocumentModule,
  EmailDocumentsModule,
  CandidateDocumentsModule,
  CandidateProfileActionsModalModule,
  CandidateProfileModule,
  UploadReqWorkFlowStepWarningModalModule,
  UploadReqUpdateLocationModalModule,
  UploadReqTransactionCandidatesModalModule,
  UploadReqJobProfileModalModule,
  UploadReqAddEditEndClientModalModule,
  ReviewCandidatePullFromJobBoardsModule,
  UserNotificationsModule
  ],
  exports: [ActionLessHeaderModule],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
